export default from './empty-comment';



// WEBPACK FOOTER //
// ./app/components/empty-comment/index.js